import React, {
  FC,
  PropsWithChildren,
  useEffect,
  useState,
  useContext,
} from "react";
import { Navigate, useLocation } from "react-router-dom";
import useUser from "../hooks/useUser";
import { getDefaultLandingPageForBusiness } from "../features/RoleManagement/services";
import { LandingPageOption } from "../features/LandingPageManagement/types/LandingPageTypes";
import NavigationLinkContext from "../contexts/NavigationLink";
import { NavListContextType } from "../contexts/NavigationLink";
const RoleBasedRedirect: FC<PropsWithChildren> = ({ children }) => {
  const { currentUser, selectedBusiness } = useUser();
  const { allowedPages } = useContext<NavListContextType>(
    NavigationLinkContext
  );
  const [defaultLandingPage, setDefaultLandingPage] =
    useState<LandingPageOption | null>(null);
  const [checked, setChecked] = useState(false);
  const location = useLocation();

  const roleLandingPage =
    currentUser?.tenant_role_groups?.[0]?.generalConfig?.defaultLandingPage
      ?.link ?? null;

  useEffect(() => {
    if (!selectedBusiness) {
      setChecked(true);
      return;
    }

    getDefaultLandingPageForBusiness(selectedBusiness.id)
      .then((data) => setDefaultLandingPage(data ?? null))
      .catch(() => {
        console.warn("No default landing page found for business");
        setDefaultLandingPage(null);
      })
      .finally(() => setChecked(true));
  }, [selectedBusiness]);

  let landingPage: string | null = null;

  if (roleLandingPage && allowedPages.includes(roleLandingPage)) {
    landingPage = roleLandingPage;
  } else if (
    defaultLandingPage?.link &&
    allowedPages.includes(defaultLandingPage.link)
  ) {
    landingPage = defaultLandingPage.link;
  } else if (allowedPages.length > 0) {
    landingPage = allowedPages[0];
  } else {
    landingPage = "/";
  }

  const isRootOrAuthPage = ["/", "/auth", "/auth/"].includes(location.pathname);

  if (!checked) {
    return <></>;
  }

  if (
    isRootOrAuthPage &&
    landingPage &&
    location.pathname !== landingPage &&
    !landingPage.startsWith("http") &&
    !landingPage.startsWith("https")
  ) {
    return <Navigate to={landingPage} replace />;
  }

  return <>{children}</>;
};

export default RoleBasedRedirect;
